// Pure helpers for the workout module. No React, no Supabase imports.

// Total volume in a session = sum of (weight × reps) for non-warmup sets only.
export function totalVolume(sets) {
  if (!Array.isArray(sets)) return 0
  return sets
    .filter((s) => !s.is_warmup)
    .reduce((sum, s) => sum + Number(s.weight_kg || 0) * Number(s.reps || 0), 0)
}

// Epley formula — for reference only. Less reliable below 5 reps and above 10.
export function estimatedOneRM(weightKg, reps) {
  if (!weightKg || !reps) return 0
  return weightKg * (1 + reps / 30)
}

// Given an exercise's full set history (newest first or oldest first — we
// flatten and find), returns the heaviest weight, biggest single-set volume,
// and most reps at any weight.
export function exercisePRs(sets) {
  if (!Array.isArray(sets) || sets.length === 0) {
    return { heaviestWeight: null, heaviestReps: null, bestSetVolume: null, bestSetVolumeReps: null, mostReps: null, mostRepsWeight: null }
  }
  const work = sets.filter((s) => !s.is_warmup)
  if (work.length === 0) return exercisePRs([])

  let heaviest = work[0]
  let bestVolume = work[0]
  let mostReps = work[0]
  for (const s of work) {
    if (Number(s.weight_kg) > Number(heaviest.weight_kg)) heaviest = s
    if (Number(s.weight_kg) * Number(s.reps) > Number(bestVolume.weight_kg) * Number(bestVolume.reps)) bestVolume = s
    if (Number(s.reps) > Number(mostReps.reps)) mostReps = s
  }
  return {
    heaviestWeight: Number(heaviest.weight_kg),
    heaviestReps: Number(heaviest.reps),
    bestSetVolume: Number(bestVolume.weight_kg) * Number(bestVolume.reps),
    bestSetVolumeReps: Number(bestVolume.reps),
    mostReps: Number(mostReps.reps),
    mostRepsWeight: Number(mostReps.weight_kg),
  }
}

// Returns the most recent set (by created_at on the parent exercise_log if
// available; otherwise input order). Used for the "last set" reference chip.
export function lastWorkingSet(sets) {
  if (!Array.isArray(sets) || sets.length === 0) return null
  const work = sets.filter((s) => !s.is_warmup)
  return work[0] || sets[0]
}

// Group exercises by muscle group, returning { chest: [...], back: [...] }
export function groupByMuscleGroup(exercises) {
  if (!Array.isArray(exercises)) return {}
  return exercises.reduce((acc, e) => {
    const key = e.muscle_group || 'other'
    if (!acc[key]) acc[key] = []
    acc[key].push(e)
    return acc
  }, {})
}
